import React from 'react';
import { Collapse, Input, Card, CardBody } from 'reactstrap';
import AppButton from './AppButton';
import { OfferDate } from './OfferDate';

export default function AuthorityToLeave(props) {
    if((props.offer.status === "Offer1" || props.offer.status === "Accepted" || props.offer.status === "Declined") &&
    (props.shipment.status !== "Cancelled" && props.shipment.status !== "Rejected" && props.shipment.atl_permitted === true)) {
        // Email from glen - redirect (checkbox) always allows overriding this
        if(props.type === "checkbox") {
            return(
                <div className="atl-check">
                    <input type="checkbox" defaultChecked={(props.shipment.atl_provided === "Receiver" || props.shipment.atl_provided === "Customer")} 
                        className="large" onClick={e=>props.updateShipment({atl_provided: e.target.checked ? "Receiver" : "No" })} />
                    <label>I authorise Fliway to leave if no-one is home and have read the&nbsp;
                        <a style={{ whiteSpace: "nowrap" }} href={props.config.termsAndConditions.authorityToLeaveUrl} target="_blank">Terms &amp; Conditions</a></label>
                </div>
            );
        }

        if(props.shipment.atl_requested === true || props.shipment.atl_provided === "Receiver") {
            return (
                <div className="atl-agreed">
                    Fliway have been authorised to leave the delivery at the premises in accordance with the ATL&nbsp; 
                    <a style={{whiteSpace: "nowrap"}} href={props.config.termsAndConditions.authorityToLeaveUrl} target="_blank">Terms &amp; Conditions</a>
                </div>
            );
        }
  
        if((!(props.shipment.atl_requested === true || props.shipment.atl_provided === "Receiver") && 
            props.shipment.status !== "Delivered" && props.shipment.status.indexOf("POD") < 0) &&
            !props.readonly){
            return (
                <React.Fragment>
                    {!props.shipment.atlInstruction && <div ref={props.myRef} className="primary-action-area agreed-area">
                        <div className="atl-description">
                            <span className="atl-text">If&nbsp;no&nbsp;one&nbsp;is<br/>home&nbsp;on
                                {props.offer.offers.length >= 1 && 
                                    (<React.Fragment>
                                        <br/><OfferDate dateOnly start_time={props.offer.offers[0].start_time} end_time={props.offer.offers[0].end_time}></OfferDate>
                                    </React.Fragment>)
                                }</span>
                        </div>
                        <i className="icon-arrow-right"></i>
                        { props.shipment.atl_provided === "Customer" ?
                            <AppButton iconName="icon-button-tick" actionText="Let us know" header={"Tap here to"} highlight
                                onClick={props.startAtl} footer={"of a safe place to leave this"}/> :
                            <AppButton iconName="icon-button-tick" actionText="Leave" header={"Tap to allow Fliway to"} highlight
                                onClick={props.startAtl} footer={"the delivery at the address"}/>
                        }
                    </div>}
                    <Collapse className="agreed-area atl-confirm" isOpen={props.shipment.confirmAtl}>
                        <Card>
                            <div className="cardCloseX" onClick={e=>props.updateShipment({confirmAtl: null})}>&times;</div>
                            <CardBody>
                                <Input placeholder="Enter instruction for where to leave the delivery." 
                                    type="textarea" name="text" value={props.shipment.atlInstruction || ''} onChange={(e) => props.updateShipment({atlInstruction: e.target.value})} />
                                <AppButton className="float-right" iconName="icon-button-tick" actionText="Confirm" highlight
                                    onClick={props.giveAtl} ajaxInProgress={props.busy}
                                    footer="Tap to confirm"/>
                                {props.shipment.atl_provided !== "Customer" &&
                                <div className="atl-terms">
                                    Authority to leave is given in accordance with the <br />
                                    <a style={{whiteSpace: "nowrap"}} href={props.config.termsAndConditions.authorityToLeaveUrl} target="_blank">Terms &amp; Conditions</a>
                                </div>}
                            </CardBody>                                
                        </Card>                            
                    </Collapse>
                    {props.shipment.atl_provided === "Customer" && 
                    <div className="atl-agreed">
                        Fliway have been authorised to leave the delivery at the premises in accordance with the ATL&nbsp; 
                        <a style={{whiteSpace: "nowrap"}} href={props.config.termsAndConditions.authorityToLeaveUrl} target="_blank">Terms &amp; Conditions</a>
                    </div>
                    }                        
                </React.Fragment>
            );
        }        
    }   

    // default is empty
    return null;
}
